module.exports = __webpack_public_path__ + "img/lg_ring_g_0_0_0@3x.224f9297.png";